import {
  IUserLibraryProgramsResponseOK,
  useInfiniteQueryUserLibraryPrograms,
  useInfiniteQueryUserLibraryProgramsCategory,
  useQueryUserLibraryProgramsCategory,
} from '@ifit/gateway-wolf-athenaeum-service';
import { UseInfiniteQueryResult, UseQueryResult } from 'react-query';
import { useParams } from 'react-router-dom';
import getNextPageParam from '../get-next-page';
import { useInfiniteQueryOptions, useRowQueryOptions } from '../query-options';
import { ProgramsParams } from '../../../views/routes';

export const useSeriesRowByCategoryInfiniteQuery = (): UseInfiniteQueryResult<IUserLibraryProgramsResponseOK> => {
  const opts = useInfiniteQueryOptions();
  const { categorySlug: categoryName } = useParams<ProgramsParams>();
  const resp = useInfiniteQueryUserLibraryProgramsCategory(
    { ...opts, categoryName },
    { getNextPageParam },
  );
  return resp;
};

export const useSeriesRowInfiniteQuery = (): UseInfiniteQueryResult<IUserLibraryProgramsResponseOK> => {
  const opts = useInfiniteQueryOptions();
  const resp = useInfiniteQueryUserLibraryPrograms(
    { ...opts, trainerId: null },
    { getNextPageParam },
  );
  return resp;
};

export const useSeriesRowByCategoryQuery = (): UseQueryResult<IUserLibraryProgramsResponseOK> => {
  const opts = useRowQueryOptions();
  const { categorySlug: categoryName } = useParams<ProgramsParams>();
  const resp = useQueryUserLibraryProgramsCategory({ ...opts, categoryName });
  return resp;
};
